import { cn } from "@/lib/utils";

export default function SectionHeading({
    eyebrow,
    title,
    subtitle,
    align = "left",
    className,
}) {
    return (
        <div
            className={cn(
                "max-w-3xl",
                align === "center" && "mx-auto text-center",
                className
            )}
        >
            {eyebrow && (
                <span className="label-mono inline-block bg-brand-yellow border-2 border-ink rounded-full px-3 py-1 mb-5">
                    {eyebrow}
                </span>
            )}
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[0.95] tracking-tighter">
                {title}
            </h2>
            {subtitle && (
                <p className="mt-5 font-body text-base md:text-lg text-ink/70 leading-relaxed">
                    {subtitle}
                </p>
            )}
        </div>
    );
}
